import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

/**
 * Password input with show/hide toggle.
 * Pass `wrapperClassName` / `inputClassName` / `toggleClassName` to match host page styles.
 */
export default function PasswordField({
  id,
  name,
  value,
  onChange,
  placeholder,
  autoComplete = "current-password",
  required = false,
  disabled = false,
  wrapperClassName = "",
  inputClassName = "",
  toggleClassName = "",
  "aria-label": ariaLabel = "Password",
}) {
  const [show, setShow] = useState(false);

  return (
    <div className={`relative ${wrapperClassName}`.trim()}>
      <input
        id={id}
        name={name}
        type={show ? "text" : "password"}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        autoComplete={autoComplete}
        required={required}
        disabled={disabled}
        aria-label={ariaLabel}
        className={inputClassName}
      />
      <button
        type="button"
        className={toggleClassName}
        onClick={() => setShow((prev) => !prev)}
        disabled={disabled}
        aria-label={show ? "Hide password" : "Show password"}
        aria-pressed={show}
        tabIndex={-1}
      >
        {show ? <EyeOff size={18} aria-hidden="true" /> : <Eye size={18} aria-hidden="true" />}
      </button>
    </div>
  );
}
